import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { MobileFeedModel } from 'src/app/models/commission/mobile-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-mobile-adjustments',
  templateUrl: './mobile-adjustments.component.html',
  styleUrls: ['./mobile-adjustments.component.css']
})
export class MobileAdjustmentsComponent implements OnInit {
  // mobileFeedModel = new MobileFeedModel();
  feedResultsData: MobileFeedModel[] = [];
  excelMobFeedResultsData: MobileFeedModel[] = [];


  feedResultsDataExcel: KomFeed[] = [];
  feedResultsRepData: KomFeed[] = [];
  rateCodeData: KomFeed[] = [];
  reportingCentersData: KomFeed[] = [];
  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  resHeadder: string = 'Mobile Feed Results';
  actions: any;
  actionButtons: any;
  buttons: Buttons[] = [];
  komfeedModel = new KomFeed();
  komfeedModel1 = new KomFeed();
  IsmodelShow: boolean = false;
  exportExcelUserData: KomFeed[] = [];
  isAccessDisabled: boolean = false;

  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;
  permissionCheck: any;
  errorMessage: string;
  delcodeid: string;
  addcodeid: string;
  currproclassid: string;
  prevproclassid: string;
  orderdt: Date;

  showVal1: boolean;
  showVal2: boolean;
  showVal3: boolean;
  showVal4: boolean;
  showVal5: boolean;
  showVal6: boolean;
  showVal7: boolean;
  showVal8: boolean;
  showVal9: boolean;
  showVal10: boolean;

  showVal11: boolean;
  showVal12: boolean;
  showVal13: boolean;
  showVal14: boolean;
  showVal15: boolean;
  showVal16: boolean;
  showVal17: boolean;
  showVal18: boolean;
  showVal19: boolean;
  showVal20: boolean;


  public rctr01: string;
  public rctr02: string;
  public rctr03: string;
  public rctr04: string;
  public rctr05: string;
  public rctr06: string;
  public rctr07: string;
  public rctr08: string;
  public rctr09: string;
  public rctr10: string;

  public rctr11: string;
  public rctr12: string;
  public rctr13: string;
  public rctr14: string;
  public rctr15: string;
  public rctr16: string;
  public rctr17: string;
  public rctr18: string;
  public rctr19: string;
  public rctr20: string;

  public rc01: string;
  public rc02: string;
  public rc03: string;
  public rc04: string;
  public rc05: string;
  public rc06: string;
  public rc07: string;
  public rc08: string;
  public rc09: string;
  public rc10: string;

  public rc11: string;
  public rc12: string;
  public rc13: string;
  public rc14: string;
  public rc15: string;
  public rc16: string;
  public rc17: string;
  public rc18: string;
  public rc19: string;
  public rc20: string;

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService, private globalService: GlobalService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('comm-plan');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  init() {
    this.getResults();
    // this.getResultsExcel();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.checkPermission();
  }

  getResults() {
    this.komFeedService.getMobileFeedSerchResults(this.commissionService.mobileFeedModel).subscribe((data: MobileFeedModel[]) => {
      this.feedResultsData = data;
      this.excelMobFeedResultsData = JSON.parse(JSON.stringify(data));
      //console.log(JSON.stringify(this.feedResultsData));
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getResultsExcel() {
    this.komFeedService.getFeedSerchResultsExcel(this.commissionService.komFeedModel).subscribe((data: KomFeed[]) => {
      this.feedResultsDataExcel = data;
      console.log(this.feedResultsDataExcel);
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getMobileFeedDataById(id: any, status: string) {
    console.log(id);
    console.log(status);
    this.komFeedService.getMobileFeedDataById(id).subscribe
      ((data: MobileFeedModel) => {
        //console.log(JSON.stringify(data));
        this.commissionService.editMobileFeedModel = data;

        this.commissionService.editMobileFeedModel[0].status = status;
        //console.log(this.commissionService.editMobileFeedModel);
        this.router.navigate(['/edit-mobileFeed']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }




  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.MobileFeedResults;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {

    //this.exportExcelUserData = JSON.parse(JSON.stringify(this.feedResultsDataExcel));

    console.log(this.excelMobFeedResultsData);
    for (let js of this.excelMobFeedResultsData) {
      delete js.mob_feed_id;
      delete js.pr_status_id;
      delete js.employee_id;
      delete js.transaction_complete_from_date;
      delete js.transaction_complete_to_date;
    }
    console.log(this.excelMobFeedResultsData);
    this.dataForExcel = [];
    let reportData = null;
    this.excelMobFeedResultsData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'Mobile Feed Data',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  public checkPermission() {
    this.errorMessage = '';
    this.menusFilter = JSON.parse(localStorage.getItem('menulist'));
    console.log(this.menusFilter);
    this.menusFilter = this.menusFilter.filter(val => this._normalizeValue(val.nav_page_name).includes(this._normalizeValue('Feed Adjustments')));
    this.permissionCheck = this.menusFilter[0].edit_acc;
    if (this.permissionCheck === "y") {
      this.isAccessDisabled = false;
    } else {
      this.isAccessDisabled = true;
    }
    console.log(this.permissionCheck);
    console.log(this.isAccessDisabled);
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }


  public deleteRowByWipByinfoId(id: number): void {
    if (confirm("Are you sure to delete this Record")) {
      this.komFeedService.deleteRowByWipByinfoId(id).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    console.log(action);
    if (action === "Add" && !this.isAccessDisabled) {
      this.router.navigate(['/add-mobileadjustments']);
      //document.getElementById(action).click();
      //this.IsmodelShow = false;;
      //document.getElementById(action).click();
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  getKomFeedDataById(id: any, status: string) {
    console.log(id);
    this.komFeedService.getKomFeedDataById(id).subscribe
      ((data: KomFeed) => {
        //console.log(JSON.stringify(data));
        this.commissionService.editKomFeedModel = data;
        //console.log(this.commissionService.editKomFeedModel.deletion_code_id.toString().padStart(1,'5'));

        this.commissionService.editKomFeedModel.status = status;
        //console.log(this.commissionService.editKomFeedModel);
        this.router.navigate(['/edit-komFeed']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getKomFeedDataByCorpHouseRep(corp: number, house: string, salesrepid: string, status: string) {
    // console.log(status);
    this.komFeedService.getKomFeedDataByCorpHouseRep(corp, house, salesrepid).subscribe
      ((data: KomFeed) => {
        //console.log(JSON.stringify(data));
        this.commissionService.editKomFeedModel = data;
        this.commissionService.editKomFeedModel.status = status;
        //console.log(this.commissionService.editKomFeedModel);
        this.router.navigate(['/edit-komFeed']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getKomFeedDataByRepId(corp: number, house: string, salesrepid: string, id: number) {
    //console.log(status);
    this.komFeedService.getKomFeedDataByRepId(corp, house, salesrepid, id).subscribe
      ((data: KomFeed[]) => {
        this.feedResultsRepData = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  update(row: any, values: any) {
    // console.log(row);
    //console.log(values);
    //console.log(values.value);
  }

  // openPopup(row: any) {
  //   //console.log(row);
  //   // console.log(row.row.corp);
  //   // console.log(row.row.ratecd);
  //   this.getRateCodeInfo(row.row.corp, row.row.ratecd);
  //   //this.getReportingCentersInfo(row.row.corp, row.row.ratecd);
  //   document.getElementById('showratecodeinfo').click();
  // }

  // getRateCodeInfo(corp: number, ratecd: string) {
  //   //console.log(status);
  //   this.komFeedService.getRateCodeInfo(corp, ratecd, this.orderdt).subscribe
  //     ((data: KomFeed[]) => {
  //       this.rateCodeData = data;
  //       // console.log(this.rateCodeData);
  //     }, (errorResponse: HttpErrorResponse) => {
  //       var msg: any;
  //       msg = errorResponse;
  //       this.notificationService.sendNotification(NotificationType.ERROR, msg);
  //     });
  // }




  close(form: NgForm, id: string) {
    console.log('======', id);
    form.reset();
    document.getElementById(id).click();
  }

  public saveNewRecord(kpiForm: NgForm): void {
    // console.log("======= ", this.feedResultsData[0].wibBuyInfoID);
    // this.komfeedModel.wibBuyInfoID = this.feedResultsData[0].wibBuyInfoID;
    this.komfeedModel.id = this.komfeedModel1.id;
    console.log("======= ", this.komfeedModel);

    this.komFeedService.saveWibByInfoData(this.komfeedModel).subscribe((data: KomFeed) => {
      this.notificationService.sendNotification(NotificationType.SUCCESS, 'Inserted Successfully');
      this.close(kpiForm, 'closeAddKPIButton');
      this.init()
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });

  }

  onAddRecord(komFeed: KomFeed) {
    this.komfeedModel1 = komFeed;
    //console.log(this.komfeedModel1.id);
    document.getElementById("Add New").click();
  }



  innerRowAction1(row: any) {
    //console.log(row);
    console.log(row.row.id);
    if (row.value === 'View') {
      this.orderdt = row.row.wordate;
      this.getKomFeedDataByRepId(row.row.corp, row.row.house, row.row.sales_rep_id, row.row.id);
    }
    if (!this.isAccessDisabled) {
      // if (row.value === 'Delete') {
      //   this.deleteRowByWipByinfoId(row.row.wibBuyInfoID);
      // } else 
      if (row.value === 'Update') {
        console.log(row.row.mob_feed_id);
        this.getMobileFeedDataById(row.row.mob_feed_id, 'Update');
        //this.getKomFeedDataByCorpHouseRep(row.row.corp, row.row.house, row.row.sales_rep_id, 'Update');
      } else if (row.value === 'Replicate') {
        this.getMobileFeedDataById(row.row.mob_feed_id, 'Replicate');
      } else if (row.value === 'Add') {
        console.log("Inside Add");
        // this.getKomFeedDataById(row.row.id, 'Replicate');
        this.onAddRecord(row.row);
        //document.getElementById("Add New").click();
      }
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  innerRowAction2(row: any) {
    console.log("innerRowAction ....", row);
    console.log("innerRowAction ....", row.value);
    if (row.value === 'Delete') {
      this.deleteRowByWipByinfoId(row.row.wibBuyInfoID);
    }

  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.MobileFeedResults;
        // this.ordersTableColumns2 = this.columnsData.KomFeedRepResults;
        //console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      // {
      //   name: 'Add',
      //   dataKey: 'fa fa-plus success f-25',
      //   position: 'left',
      //   isSortable: false,
      //   class: 'badge bg-success'
      // },
      // {
      //   name: 'Delete',
      //   dataKey: 'far fa-trash-alt danger f-25',
      //   position: 'left',
      //   isSortable: false,
      //   class: 'badge bg-danger'
      // },
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
      ,
      {
        name: 'Replicate',
        dataKey: 'far fa-clone primary f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-success btn-xs'
      }
    ]
    this.buttons = [
      {
        name: 'Back',
        pagenavigation: 'adjustments-feed'
      }
    ]
  }

}